var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.335 11a6.335 6.335 0 1 1-12.67 0 6.335 6.335 0 0 1 12.67 0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.335 11a6.335 6.335 0 1 0-6.499 6.333l.164.003a6.335 6.335 0 0 0 6.333-6.172l.003-.164ZM18 11a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.24 8.363c0-.34.275-.615.614-.615h.165c.34 0 .615.275.615.615v.164c0 .34-.275.615-.615.615h-.165a.615.615 0 0 1-.614-.615v-.164ZM10.24 11.233a.697.697 0 1 1 1.394 0v3.02a.697.697 0 1 1-1.394 0v-3.02Z",
    fill: "currentColor"
  })));
};
export default SvgInfo;